import { APP_URL } from '../../constants';
import { useLanguage } from '../../i18n/LanguageContext';

function WhatSection() {
    const { t } = useLanguage();

    return (
        <section className="what" id="what">
            <div className="wrap">
                <div className="what-head rv">
                    <span className="eyebrow">{t.whatEyebrow}</span>
                    <h2>
                        {t.whatTitle}{' '}
                        <span className="grad">{t.whatTitleAccent}</span>
                    </h2>
                    <p>{t.whatLead}</p>
                </div>
                <div className="pipe">
                    <div className="panel pipe-step rv" style={{ '--rv-delay': '0ms' }}>
                        <span className="n">{t.pipe1Label}</span>
                        <h3>{t.pipe1Title}</h3>
                        <p>{t.pipe1Text}</p>
                        <div className="chains" style={{ margin: 0 }}>
                            <span className="chain">
                                <i style={{ background: '#37d39a' }} />
                                Card
                            </span>
                            <span className="chain">
                                <i style={{ background: '#ff4d4d' }} />
                                Tron
                            </span>
                            <span className="chain">
                                <i style={{ background: '#2aa4f4' }} />
                                TON
                            </span>
                            <span className="chain">
                                <i style={{ background: '#9a6bff' }} />
                                Solana
                            </span>
                            <span className="chain">+3</span>
                        </div>
                    </div>
                    <div className="pipe-arrow" aria-hidden="true">
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
                            <path d="M5 12h14M13 6l6 6-6 6" />
                        </svg>
                    </div>
                    <div className="panel pipe-step rv" style={{ '--rv-delay': '90ms' }}>
                        <span className="n">{t.pipe2Label}</span>
                        <div className="coin-big">1:1</div>
                        <h3>{t.pipe2Title}</h3>
                        <p>{t.pipe2Text}</p>
                    </div>
                    <div className="pipe-arrow" aria-hidden="true">
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
                            <path d="M5 12h14M13 6l6 6-6 6" />
                        </svg>
                    </div>
                    <div className="panel pipe-step rv" style={{ '--rv-delay': '180ms' }}>
                        <span className="n">{t.pipe3Label}</span>
                        <h3>{t.pipe3Title}</h3>
                        <p>{t.pipe3Text}</p>
                        <div className="pipe-uses">
                            <a href={APP_URL}>
                                <i style={{ background: '#53a9f3' }} />
                                {t.svcGiftCards}
                            </a>
                            <a href={APP_URL}>
                                <i style={{ background: '#5fd4e6' }} />
                                {t.svcEsims}
                            </a>
                            <a href={APP_URL}>
                                <i style={{ background: '#a98bff' }} />
                                Travel
                            </a>
                            <a href="#red-packets">
                                <i style={{ background: '#ff6b5f' }} />
                                {t.navPackets}
                            </a>
                            <a href="#rewards">
                                <i style={{ background: '#f3c66b' }} />
                                {t.ddCashback}
                            </a>
                            <a href={APP_URL}>
                                <i style={{ background: '#37d39a' }} />
                                Wallet
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default WhatSection;
